export default __webpack_public_path__ + "static/media/noq-video.3f301f0c.mp4";